'use strict';

// Export web by default. Other platforms have custom index.[platform].js files
module.exports = require('./dist/web/PluginBase.js');



//////////////////
// WEBPACK FOOTER
// ./~/reactxp-video/index.js
// module id = 744
// module chunks = 0